import { useEffect } from 'react';

import { EVENT_NEW_NOTIFICATION } from 'App/components/WebSocket';

import { useQueryClient } from '@gogame/query';
import { useSocket } from '@gogame/sockets';

import { grid } from './queryKeyFactory';

//TODO: prefetch function for data
export const useSocketNewNotifications = () => {
  const queryClient = useQueryClient();
  const socket = useSocket();

  useEffect(() => {
    const handleReceiveNewNotification = (message) => {
      queryClient.setQueryData(grid(), ({ list, unread }) => {
        return {
          unread: unread + 1,
          list: [message, ...list],
        };
      });
    };

    socket.on(EVENT_NEW_NOTIFICATION, handleReceiveNewNotification);
    return () => {
      socket.off(EVENT_NEW_NOTIFICATION, handleReceiveNewNotification);
    };
  }, [socket]);
};
